export default __webpack_public_path__ + "static/media/servicesBanner.69c478a1.jpg";